import { DonateConfirmationPage } from "@fwa/src/components/DonateConfirmationPage";
import Head from "next/head";

const Page = () => (
  <>
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
    <DonateConfirmationPage />
  </>
);

export default Page;
